module.exports = __webpack_public_path__ + "img/325.png";